<template>
  <Navbar title="add vehicle" />
  <div class="select-vehicle">
    <van-steps class="large-steps" :active="active">
      <van-step v-for="(item, index) in steps" :key="index">
        <template #inactive-icon>
          <template v-if="active > index">
            <van-icon
              class="active-icon"
              :name="item.activeIcon"
              color="#FDBB2B"
              @click="handleSelectStep(item, index)"
            />
          </template>
          <template v-else>
            <van-icon :name="item.inactiveIcon" :class="active === index ? 'has-select' : ''" />
          </template>
        </template>
        <template #active-icon>
          <van-icon class="active-icon" :name="item.inactiveIcon" color="#FDBB2B" />
        </template>
        {{ item.text }}
      </van-step>
    </van-steps>
    <div class="select-desc">
      <span class="mr10 font-600">{{ getStepsValue('year') }}</span>
      <span class="mr10 font-600">{{ getStepsValue('make') }}</span>
      <span class="mr10 font-600">{{ getStepsValue('model') }}</span>
      <span class="mr10 font-600">{{ getStepsValue('trim') }}</span>
      <span class="mr10 font-600">{{ getStepsValue('engine') }}</span>
      <span class="mr10 font-600">{{ getStepsValue('submodel') }}</span>
    </div>
    <div v-for="(step, index) in steps" :key="step.key">
      <selectConfig
        v-if="active === index"
        :key="step.key"
        v-model:value="step.value"
        :options="step.options"
        :lay-flat="step.layFlat"
        @select="handleSelect(step.key, $event)"
      />
    </div>
    <template v-if="active.value === steps?.value?.length">
      <div v-for="item in selectedVehicleList" :key="item.vpid" class="vehicle-select-list">
        <div class="font-size-16" @click="handleConfirm(item)">
          <span class="mr10">{{ item.year }}</span>
          <span class="mr10">{{ item.make }}</span>
          <span class="mr10">{{ item.model }}</span>
          <span class="mr10">{{ item.trim }}</span>
          <span class="mr10">{{ item.engine }}</span>
          <span class="mr10">{{ item.type === 1 ? item.driveType : item.submodel }}</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup>
import Navbar from '@/components/navbar/navbar.vue'
import selectConfig from './selectConfig.vue'
import { useGarageStore } from '@/store/garage'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const garageStore = useGarageStore()

const active = ref(0)

const iconConfig = { inactiveIcon: 'circle', activeIcon: 'checked' }
// console.log('route?.query?.type', route?.query?.type)
const vehicleType = computed(() => route?.query?.type)

const selectedVehicleList = ref([])

const carSteps = ref([
  {
    text: t('message.garage.Year'),
    key: 'year',
    value: '',
    options: [],
    layFlat: true,
    ...iconConfig
  },
  {
    text: t('message.garage.Make'),
    key: 'make',
    value: '',
    options: [],
    ...iconConfig
  },
  {
    text: t('message.garage.Model'),
    key: 'model',
    value: '',
    options: [],
    ...iconConfig
  },
  {
    text: t('message.garage.Trim'),
    key: 'trim',
    value: '',
    options: [],
    ...iconConfig
  },
  {
    text: t('message.garage.Engine'),
    key: 'engine',
    value: '',
    options: [],
    ...iconConfig
  }
])
const motoSteps = ref([
  {
    text: t('message.garage.Year'),
    key: 'year',
    value: '',
    options: [],
    layFlat: true,
    ...iconConfig
  },
  {
    text: t('message.garage.Make'),
    key: 'make',
    value: '',
    options: [],
    ...iconConfig
  },
  {
    text: t('message.garage.Model'),
    key: 'model',
    value: '',
    options: [],
    ...iconConfig
  },
  {
    text: t('message.garage.Submodel'),
    key: 'submodel',
    value: '',
    options: [],
    ...iconConfig
  }
])
const steps = computed(() => {
  return route.query.type === 'car' ? carSteps.value : motoSteps.value
})

const vehicleTypeNumber = computed(() => {
  if (vehicleType.value === 'car') return 1
  if (vehicleType.value === 'moto') return 2
  return null
})

const stepsKeyList = computed(() => steps.value.map((e) => e.key))

watch(active, (val) => {
  steps.value.forEach((e, i) => {
    if (i > val) {
      e.options = []
      e.value = null
    }
    if (i === val) {
      e.value = null
    }
  })
})

const getStepsValue = (type) => {
  const step = steps.value.find((item) => item.key === type)
  return step?.value
}

const getSelectOptions = (data, stepType, cb) => {
  data.type = vehicleTypeNumber.value
  garageStore.getOptions(data).then((res) => {
    const list = res?.data?.selectList || []
    if (stepType) {
      const item = steps.value.find((e) => e.key === stepType)
      item.options = list.map((e) => ({ name: e }))
    }
    cb && cb(res)
  })
}

const typeIndex = { year: 0, make: 1, model: 2, trim: 3, engine: 4, submodel: 3 }

const handleSelect = (type, value) => {
  const params = {}
  steps.value.forEach((e, i) => {
    if (i < typeIndex[type] + 1) {
      params[e.key] = e.value
    }
  })
  const nextStepKey = stepsKeyList.value[typeIndex[type] + 1]
  getSelectOptions(params, nextStepKey, (res) => {
    if (res.success) {
      if (typeof typeIndex[type] === 'number') {
        active.value = typeIndex[type] + 1
      }

      if (active.value === steps.value.length) {
        const selectedCarObject = {}
        steps.value.forEach((item) => {
          selectedCarObject[item.key] = item.value
        })
        selectedCarObject.type = vehicleTypeNumber.value
        garageStore.getCarListBySelect(selectedCarObject).then((res) => {
          if (res.success) {
            selectedVehicleList.value = res.data
            if (res?.data && res?.data?.length === 1) {
              handleConfirm(res.data[0])
            }
          }
        })
      }
    }
  })
}

const handleConfirm = async (item) => {
  await garageStore.getGarageCarList({})
  garageStore.updateSelectedCar({ ...item, type: vehicleTypeNumber.value })
  router.push('/confirmVehicle')
}

const handleSelectStep = (item, index) => {
  active.value = index
}

onMounted(() => {
  getSelectOptions({}, 'year')
})
</script>
<style lang="scss">
.select-vehicle {
  padding: 10px;
}
.vehicle-select-list {
  color: #fdbb2b;
  margin-top: 20px;
}
.select-desc {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
  padding: 0 10px;
}
.has-select {
  background-color: #fdbb2b;
  color: #fdbb2b;
  border-radius: 50%;
}
.active-icon {
  font-size: 16px;
}
</style>
